import {EventPromoView} from '_types'
import {analyticsLogEvent} from '_analytics/api'

const eventName = 'promoView'

interface Parameters {
    name?: string
    id: string
    position: number
    creative: string
}

/**
 * Tracks a quick cart add event triggered by the user.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {string} params.name - Id of the page including the page designer module
 * @param {string} params.id - Name of the module on page designer
 * @param {number} params.position - Position of the module in the page.
 * @param {number} params.creative - Name of the module type.
 */
export function analyticsEventPromoView({id, creative, position, name}: Parameters) {
    const eventDetails: EventPromoView = {
        ecommerce: {
            promoView: {
                promotions: [
                    {
                        id: id,
                        creative: creative,
                        position: position,
                        name: name,
                    },
                ],
            },
        },
    }

    analyticsLogEvent(eventName, eventDetails)
}
